// extracted by mini-css-extract-plugin
export default {"incidentId":"Cases_incidentId__FQmMy","outerContainer":"Cases_outerContainer__D74-C"};